<template>
  <div>
    <div class="this-header" v-show="title">
      <div class="web-vs web-header">
        <Weblogo width="55" height="30" />
        <strong>{{ title }}</strong>
        <Profile v-show="!noProfile" />
      </div>
      <div class="web-vs side-nav">
        <v-app-bar-nav-icon @click="drawer = true">
          <IconNavback />
        </v-app-bar-nav-icon>
      </div>
      <v-app-bar height="72px" style="left: 50%; transform: translate(-50%, 0)" max-width="760" width="100%"
        :class="'pa-3 pl-2 pr-2 mb-vs ' + bgColor" flat app clipped-left>
        <v-app-bar-nav-icon @click="drawer = true">
          <IconNavback />
        </v-app-bar-nav-icon>
        <v-toolbar-title class="pl-0" @click="drawer = true">
          <strong class="ds-b ft-l fts21 ftw5 lh48">{{ title }}</strong>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <Profile v-show="!noProfile" />
      </v-app-bar>

      <v-navigation-drawer v-model="drawer" fixed left temporary class="pwidth90 pheight100 mw-400">
        <div class="nav-header pt24" @click="drawer = !drawer">
          <a>
            <IconNavboxback />
          </a>
          <strong>SMART LYNN</strong>
        </div>
        <v-list nav dense>
          <v-list-group no-action :value="menu == 'info'">
            <template v-slot:activator>
              <v-list-item-content><v-list-item-title
                  class="text-left text-h6">단지안내</v-list-item-title></v-list-item-content>
            </template>
            <v-list-item>
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                    @click.stop="routerVillage(0)"
                    style="color: #3c3c3c">분양단지</a></v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                    @click.stop="routerVillage(1)"
                    style="color: #3c3c3c">공사단지</a></v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                    @click.stop="routerVillage(2)"
                    style="color: #3c3c3c">입주단지</a></v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><router-link
                    style="color: #3c3c3c"
                    :to="{ name: 'parcellingCalendar' }">분양일정</router-link></v-list-item-title></v-list-item-content>
            </v-list-item>
          </v-list-group>


          <v-list-group no-action :value="menu == 'csCenter'">
            <template v-slot:activator>
              <v-list-item-content><v-list-item-title class="text-left text-h6"><router-link :to="{ name: 'csCenter' }"
                    style="color: #3c3c3c">고객지원</router-link></v-list-item-title></v-list-item-content>
            </template>
            <v-list-item>
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><router-link
                    :to="{ name: 'notice' }"
                    style="color: #3c3c3c">공지사항</router-link></v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><router-link to="/faq"
                    style="color: #3c3c3c">도움말</router-link></v-list-item-title></v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-group no-action :value="menu == 'csCenter'">
            <template v-slot:activator>
              <v-list-item-content><v-list-item-title
                  class="text-left text-h6">예약</v-list-item-title></v-list-item-content>
            </template>
            <v-list-item>
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><router-link
                    :to="{ name: 'reservationList' }" class="text-left text-h6 color-6">당첨자/예비당첨자
                    방문예약</router-link></v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><router-link
                    :to="{ name: 'resaleReservationList' }" class="text-left text-h6 color-6">전매(명의변경)
                    방문예약</router-link></v-list-item-title></v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><router-link
                    :to="{ name: 'precheckReservationList' }" class="text-left text-h6 color-6">사전점검
                    방문예약</router-link></v-list-item-title></v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><router-link
                    :to="{ name: 'visitReservationForm' }" class="text-left text-h6 color-6">견본주택
                    방문예약</router-link></v-list-item-title></v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><router-link
                    :to="{ name: 'moveinReservationList' }"
                    class="text-left text-h6 color-6">입주예약</router-link></v-list-item-title></v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-group no-action :value="menu == 'contract'" v-if="!['NONMEMBER', 'MEMBER'].includes(userState)">
            <template v-slot:activator>
              <v-list-item-content><v-list-item-title
                  class="text-left text-h6">계약/입주</v-list-item-title></v-list-item-content>
            </template>

            <!-- 메뉴 커스텀 단지 / div 단위로 이렇게 별도 구성이 관리 용이할것으로 보임 -->
            <div class="ml-4" v-if="isOnlyRentVillage">
              <v-list-item v-if="is_rent && is_contractor">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                      @click="moveto('/rent/receipt')" style="color: #3c3c3c">임대료
                      조회</a></v-list-item-title></v-list-item-content>
              </v-list-item>
            </div>
            <div class="ml-4" v-else>
              <!-- 분양메뉴 -->
              <v-list-item v-if="!is_rent && is_contractor">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                      @click="moveto('/contractInfo/status/sell')" style="color: #3c3c3c">계약정보
                      조회</a></v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item v-if="!is_rent && is_contractor">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                      @click="moveto('/contractInfo/payment/payment')" style="color: #3c3c3c">납부현황
                      조회</a></v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item v-if="!is_rent && is_contractor && !hideMenuCustom01">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                      @click="moveto('/contractInfo/loan/loan')" style="color: #3c3c3c">융자현황
                      조회</a></v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item v-if="!is_rent && is_contractor && !hideMenuCustom01">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                      @click="moveto('/contractInfo/interest/interest')"
                      style="color: #3c3c3c">대납이자·보증수수료</a></v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item v-if="!is_rent && is_contractor && !hideMenuCustom01">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                      @click="moveto('/contractInfo/balance/balance')" style="color: #3c3c3c">잔금납부
                      안내</a></v-list-item-title></v-list-item-content>
              </v-list-item>
              <!-- 임대 메뉴 -->
              <v-list-item v-if="is_rent && is_contractor">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                      @click="moveto('/contractInfo/status/rent')" style="color: #3c3c3c">계약정보
                      조회</a></v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item v-if="is_rent && is_contractor">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                      @click="moveto('/contractInfo/receipt/deposit')" style="color: #3c3c3c">보증금·임대료
                      조회</a></v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item v-if="is_rent && is_contractor && showRentProjectMenu">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                      @click="moveto('/contractInfo/modusign/modusign')" style="color: #3c3c3c">전자서명
                      조회</a></v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item v-if="is_rent && is_contractor && showRentProjectMenu">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                      @click="moveto('/contractInfo/autoWithdraw/autoWithdraw')" style="color: #3c3c3c">자동출금
                      조회</a></v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item v-if="is_rent && is_contractor && showRentProjectMenu">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                      @click="moveto('/contractInfo/rentFree/rentFree')" style="color: #3c3c3c">렌트프리
                      조회</a></v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item v-if="is_rent && is_contractor">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                      @click="moveto('/contractInfo/loan/loan')" style="color: #3c3c3c">융자현황
                      조회</a></v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item v-if="is_rent && is_contractor">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                      @click="moveto('/contractInfo/interest/interest')"
                      style="color: #3c3c3c">대납이자·보증수수료</a></v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item v-if="is_rent && is_contractor">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                      @click="moveto('/contractInfo/request/change')" style="color: #3c3c3c">계약 변경 방문
                      예약</a></v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item v-if="is_rent && is_contractor">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                      @click="moveto('/contractInfo/renew/renew')" style="color: #3c3c3c">계약 갱신 방문
                      예약</a></v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item v-if="is_rent && is_contractor">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                      @click="moveto('/contractInfo/cancel/cancel')" style="color: #3c3c3c">계약 해지 방문
                      예약</a></v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item v-if="is_rent && is_contractor">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                      @click="moveto('/contractInfo/before/leave')" style="color: #3c3c3c">중도 퇴거
                      신청</a></v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item v-if="is_rent && is_contractor">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                      @click="moveto('/contractInfo/on/leave')" style="color: #3c3c3c">만기 퇴거
                      신청</a></v-list-item-title></v-list-item-content>
              </v-list-item>
              <v-list-item v-if="is_contractor && reservableList.length > 0">
                <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><router-link to="/contract"
                      style="color: #3c3c3c">
                      기타 방문 예약
                      <!-- <span class="nav-state on"
                      >{{ reservableList.length }}건</span
                    > -->
                      <!-- on 빠지면 불꺼짐 -->
                    </router-link></v-list-item-title></v-list-item-content>
              </v-list-item>

            </div>

            <!-- 계약 회원이 아닐 때.. -->
            <v-list-item v-if="!is_contractor">
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                    @click="moveto('/contractInfo/status/sell')" style="color: #3c3c3c">계약정보
                    조회</a></v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item v-if="!is_contractor">
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                    @click="moveto('/contractInfo/payment/payment')" style="color: #3c3c3c">납부현황
                    조회</a></v-list-item-title></v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-group no-action :value="menu == 'dwelling'" v-if="!['NONMEMBER', 'MEMBER'].includes(userState)">
            <template v-slot:activator>
              <v-list-item-content><v-list-item-title
                  class="text-left text-h6">린라이프</v-list-item-title></v-list-item-content>
            </template>
            <v-list-item>
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                    @click.prevent.stop="dwellingMoveTo('/mgmtFee')"
                    style="color: #3c3c3c">관리비</a></v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item  v-if="is_service_fee_enabled">
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                    @click.prevent.stop="dwellingMoveTo('/serviceFee')"
                    style="color: #3c3c3c">서비스 사용료</a></v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                    @click.prevent.stop="dwellingMoveTo('/facilityHome')" style="color: #3c3c3c">시설
                    안내·예약</a></v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a
                    @click.prevent.stop="dwellingMoveTo('/voteList')" style="color: #3c3c3c">입주민
                    투표</a></v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><a @click="
                $router.push({
                  name: 'noticeVillage',
                  query: { type_sub_code: '' },
                })
                " style="color: #3c3c3c">단지소식</a></v-list-item-title></v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-group no-action :value="menu == 'mypage'" v-if="$store.state.auth.isLoggedIn">
            <template v-slot:activator>
              <v-list-item-content><v-list-item-title
                  class="text-left text-h6">마이페이지</v-list-item-title></v-list-item-content>
            </template>
            <v-list-item>
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><router-link
                    :to="{ name: 'mypage', params: { tabIndex: 3 } }" style="color: #3c3c3c">나의 예약 및
                    신청현황</router-link></v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item v-show="user && user.is_accepted">
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1">
                  <router-link to="/familyMember" style="color: #3c3c3c">가족 구성원 관리</router-link>
                </v-list-item-title></v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content><v-list-item-title class="text-left text-subtitle-1"><router-link
                    to="/memberInfoUpdate" style="color: #3c3c3c">회원정보
                    수정</router-link></v-list-item-title></v-list-item-content>
            </v-list-item>
          </v-list-group>

        </v-list>

        <div class="nav-bottom">
          <router-link to="/noticeIn/855" class="nav-fullItem">스마트린 사용 가이드(메뉴얼)</router-link>
          <router-link :to="{ name: 'notice' }" class="nav-bItem">공지사항</router-link>
          <router-link to="/faq" class="nav-bItem">도움말</router-link>
          <router-link :to="{ name: 'smartLynn' }" class="nav-bItem end">스마트린소개</router-link>
        </div>
      </v-navigation-drawer>
    </div>
    <v-fab-transition>
      <v-btn v-show="readyToScroll" color="rgba(255,255,255,0.85)" elevation="2" fixed bottom right
        @click="scrollToTop()" fab dark style="margin-bottom: 56px" small>
        <v-icon color="primary" large>mdi-chevron-up</v-icon>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<style>
a.router-link-active {
  color: #e66a1f !important;
}

.v-list-item {
  margin-bottom: 0 !important;
}

.v-application .text-h6 {
  font-family: "Noto Sans KR" !important;
  font-weight: 500 !important;
  font-size: 17px !important;
}
</style>

<script>
import Weblogo from "@/assets/images/common/new-logo.svg";
import IconNavboxback from "@/assets/images/icon/icon-back.svg";
import IconNavback from "@/assets/images/icon/icon-navback.svg";
import Profile from "@/components/Profile";

import { getReservableList } from "@/api/index.js";

export default {
  components: {
    // Nav,
    Profile,
    IconNavback,
    IconNavboxback,
    Weblogo,
  },
  name: "Header",
  data() {
    return {
      drawer: false,
      group: null,
      readyToScroll: false,
      reservableList: [],
    };
  },
  computed: {
    is_development() {
      return process.env.NODE_ENV !== "production";
    },
    showRentProjectMenu(){
      /**
       * 임대프로젝트 통합테스트(운영)를 위해 테스트 단지만 메뉴 노출(TODO: 통합테스트 이후 삭제 예정)
       */
      if(this.is_development) return true;

      return this.home && (this.home.erp_village_id == "BQ00P0999D" || this.home.erp_village_id == "BQ00P0888D");
    },
    header() {
      if (this.$route.meta.header) {
        return this.$route.meta.header;
      } else {
        return {
          title: "",
        };
      }
    },
    title() {
      return this.header.title;
    },
    noProfile() {
      return this.header.noProfile;
    },
    bgColor() {
      if (this.header.bgWhite) {
        return "bg-white";
      } else {
        return "bg-gray";
      }
    },
    menu() {
      return this.$route.meta.activeMenu;
    },
    userState() {
      return this.$store.getters.getUserState;
    },
    switchMode() {
      return this.$store.state.switchMode;
    },
    home() {
      return this.$store.getters.getHome;
    },
    user() {
      return this.$store.getters.getUser;
    },
    hub() {
      return this.$store.state.hub;
    },
    is_rent() {
      if (this.home) {
        return this.home.is_rent;
      }
      return false;
    },
    is_contractor() {
      if (this.home) {
        return this.home.is_contractor;
      }
      return false;
    },
    hideMenuCustom01() {
      return this.home && this.home.erp_village_id == "AA00P0167D";
    },
    isOnlyRentVillage() {
      /*
      2024-12-31 현재 센터스퀘어 등촌 임대의 경우 운영 이관으로 계약정보 상 불일치가 발생할 수 있어 미사용.
      임대 메뉴만 사용, 해당 메뉴는 별도 단일 페이지로 구성됨
      */
      return this.home && this.home.erp_village_id == "BQ00P0503D";
    },
    tenantHome() {
      return this.$store.getters.getTenantHome;
    },
    is_service_fee_enabled() {
      /**
       서비스 사용료 활성화 여부
       입주세대가 있고, 서비스 사용료 사용 단지인 경우 
       */
      return this.tenantHome && this.tenantHome.is_using_erp_service_fee;
    },
  },
  methods: {
    moveto(path) {
      if (!this.user) {
        this.$router.push({ name: "login" });
        return;
      }
      if (path == "/contract" && !this.user.is_verified_name) {
        this.$store.commit("SUCCESS", "계약자를 위한 서비스입니다.");
        return;
      }

      if (path.indexOf("contractInfo") > 0 && !this.is_contractor) {
        this.$store.commit("SUCCESS", "계약자를 위한 서비스입니다.");
        return;
      }
      if (path == "/contractInfo/balance/balance") {
        if (!this.home.is_display_balance_info) {
          this.$store.commit("ERROR", "잔금납부 안내 기간이 아닙니다.");
          return;
        }
      } else if (path == "/contractInfo/request/change") {
        // 계약 변경 신청 가능 여부
        if (!this.home.contract_reservation.CHANGE) {
          this.$store.commit("ERROR", "계약변경 신청기간이 아닙니다.");
          return;
        }
      } else if (path == "/contractInfo/renew/renew") {
        // 계약 갱신 신청 가능 여부
        if (!this.home.contract_reservation.RENEW) {
          this.$store.commit("ERROR", "계약갱신 신청기간이 아닙니다.");
          return;
        }
      } else if (path == "/contractInfo/cancel/cancel") {
        // 계약 해지
        if (!this.home.contract_reservation.TERMINATE_BEFORE_CONTRACT) {
          this.$store.commit("ERROR", "계약해지 신청기간이 아닙니다.");
          return;
        }
      } else if (path == "/contractInfo/before/leave") {
        // 중도퇴거
        if (!this.home.contract_reservation.TERMINATE_BEFORE_PERIOD) {
          this.$store.commit("ERROR", "중도퇴거 신청기간이 아닙니다.");
          return;
        }
      } else if (path == "/contractInfo/on/leave") {
        // 만기퇴거
        if (!this.home.contract_reservation.TERMINATE_ON_PERIOD) {
          this.$store.commit("ERROR", "만기퇴거 신청기간이 아닙니다.");
          return;
        }
      }

      if (!path) return;
      else if (this.$route.path == path) return;

      this.$router.push({ path: path });
    },
    switchTo(link) {
      this.$store.state.switchMode = !this.$store.state.switchMode;

      if (link == "contract") {
        // 계약,주거 서비스 이동
        if ("CONTRACTOR" == this.userState) {
          this.$router.push({ name: "contract" });
        } else if ("TENANT" == this.userState) {
          this.$router.push({ name: "dwelling" });
        }
      } else {
        this.$router.push({ name: link });
      }
    },
    wait() {
      this.$store.commit("SUCCESS", "서비스 준비중입니다.");
    },
    routerVillage(tab) {
      if (this.$route.name == "villageInfoList") {
        this.$store.state.navTabIndex = tab;
        this.drawer = !this.drawer;
      } else {
        this.$router.push({
          name: "villageInfoList",
          params: { tabIndex: tab },
        });
      }
    },
    routerVillage2(tab) {
      if (this.$route.name == "villageInfoList") {
        this.$store.state.navTabIndex = tab;
      } else {
        this.$router.push({
          name: "villageInfoList",
          params: { tabIndex: tab },
        });
      }
    },
    scrollDetect() {
      this.readyToScroll = window.scrollY > 100;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    },
    dwellingMoveTo(path) {
      //this.user.is_accepted == true 이면 입주자로 간주됨
      if (!this.user || !this.user.is_accepted) {
        this.$store.commit("SUCCESS", "입주자를 위한 서비스입니다.");
        return;
      }

      if (!path) return;
      else if (this.$route.path == path) return;

      this.$router.push({ path: path });
    },

    getReservableListAPI() {
      getReservableList(this.home.id, "").then((res) => {
        this.reservableList = res.data;
      });
    },
  },
  created() {
    // 비회원, 일반회원인 경우엔 switchMode를 false로 유지
    if (["NONMEMBER", "MEMBER"].includes(this.userState)) {
      this.$store.state.switchMode = false;
    }
    if (this.is_contractor) {
      this.getReservableListAPI();
    }
    window.addEventListener("scroll", this.scrollDetect);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollDetect);
  },
};
</script>